import apiURLBuilder from '../core/apiURLBuilder';
import Api from '../services/api';
import { history } from 'routes/history';
import { actions as formActions } from 'react-redux-form';
import { formatText } from 'core/i18n';
import actionTypes from 'constants/actionTypes';
import { BASE_PATH } from 'constants/index';
import { INFRA_TIMEOUT } from 'constants/errorTypes';
import { startPolling } from './polling';
import { post } from '../utilities/APIRequestHelper';
import { getOSName } from 'utilities/browser';
import { buildTgssFiocBody } from './buildTgssFiocData';

const STATUS_CREATING = 'CREATING';
const LOAN_CREATE = 'loan';
const CLIENT_CREATE = 'client';

const handleCommonResponse = (dispatch, response, callback) => {
    const data = response.body;
    if (data && data.status === 'batch') {
        dispatch({
            type: actionTypes.BATCH_ERROR,
            data: true,
        });
    }
    if (data && data.status === 'OK') {
        dispatch(formActions.change('userProfile.userId', data.tipoPersona + data.codigoPersona));
        callback(true, data.tipoPersona + data.codigoPersona);
    }
};

const handleVerification = response => {
    const {
        ok,
        body: { status },
    } = response;
    if (ok && status !== STATUS_CREATING) {
        return false;
    }

    return true;
};

const handleFinish = (response, stats, dispatch, callback) => {
    const { ok } = stats;
    const {
        body: { status },
    } = response;
    if (ok && status !== STATUS_CREATING) {
        handleCommonResponse(dispatch, response, callback);
    } else {
        history.push(`${BASE_PATH}/errors`);
    }
};

const createClientService = (dispatch, getState, accessToken, callback, type) => {
    const baseBody = {
        operatingSystem: getOSName(),
    };

    const configByType = {
        [CLIENT_CREATE]: {
            body: {
                ...baseBody,
                ...dispatch(buildTgssFiocBody({ withDocumentation: false })),
            },
            path: 'createClientV2',
        },
        [LOAN_CREATE]: { body: baseBody, path: 'loanCreate' },
    };
    Api.post(apiURLBuilder.getURL(configByType[type].path), {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: configByType[type].body,
    }).then(
        response => {
            handleCommonResponse(dispatch, response, callback);
        },
        ({ body, status }) => {
            let defaultError = true;
            if (body && body.errors) {
                if (body.errors[8020] || body.errors[8022]) {
                    defaultError = false;
                    dispatch(formActions.change('userProfile.errorIconClass', 'icons icons--icon-warning'));
                    dispatch(
                        formActions.change('userProfile.errorTitle', formatText('messagesScreen-norkomErrorTitle'))
                    );
                    dispatch(formActions.change('userProfile.errorSubtitle', ''));
                    dispatch(formActions.change('userProfile.errorContent', 'messagesScreen-norkomErrorContent'));
                    dispatch(formActions.change('userProfile.buttonText', formatText('button-understood')));
                    dispatch(formActions.change('userProfile.buttonClass', 'form__button form__button-secondary'));
                    history.push(`${BASE_PATH}/errors`);
                }
                if (body.errors[7000]) {
                    defaultError = false;
                    dispatch({
                        type: actionTypes.BATCH_ERROR,
                        data: true,
                    });
                }
            }

            if (status === INFRA_TIMEOUT) {
                defaultError = false;
                dispatch(
                    startPolling({
                        asyncFetch: () => post('recoverClient'),
                        callback: handleVerification,
                        callbackEnd: (response, stats) => handleFinish(response, stats, dispatch, callback),
                        delay: 10,
                        ttl: 4,
                        retryOnFailure: false,
                    })
                );
            }

            if (defaultError) {
                dispatch(formActions.change('userProfile.buttonText', formatText('button-understood')));
                history.push(`${BASE_PATH}/errors`);
            }
        },
        () => {
            callback(false);
        }
    );
};

const createClient = (accessToken, callback) => {
    return (dispatch, getState) => {
        createClientService(dispatch, getState, accessToken, callback, CLIENT_CREATE);
    };
};

const loanCreate = (accessToken, callback) => {
    return (dispatch, getState) => {
        createClientService(dispatch, getState, accessToken, callback, LOAN_CREATE);
    };
};

export default {
    createClient,
    loanCreate,
};
